import $ from "jquery";
import fb from "@bd-core/firebase";
import Storage from "@bd-utils/storage";
import BD_Component from "../core/bd-component";
import compile from "../utils/handlerbars-helper";
import {
    addDocument,
    getFeedback,
    // getDocuments,
    maybeUpdateRoomStatus,
    updateFeedback,
    updateFinalRoomAnswer,
} from "@bd-core/firebase-actions";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { getDocuments, getRoomStartedAt, getRoomStatus } from "@bd-stores/game-progress";
import CONFIG from "@bd-core/config";
export class RoomEmailApp extends BD_Component {
    constructor() {
        super();

        this.id = "email_app";
        this.templateID = "email_app-template";

        this.elms = {
            pointerBtn: ".js-pointer",
            closePopupBtn: ".js-close-popup",
            imageBox: ".js-imagebox",
            imageBoxFullscreen: ".js-imagebox-fullscreen",
            openFullscreenBtn: ".js-open-imagebox-fullscreen",
            closeFullscreenBtn: ".js-close-popup-fullscreen",
            imageBoxImg: ".js-imagebox-img",
            shareBtn: ".js-share-btn",
            submitBtn: ".js-submit-email",

            laptop: "#popup-laptop",
            laptopOpen: '[data-open="popup"][data-target="#popup-laptop"]',
            laptopClose: ".js-close-laptop-screen",
            laptopMainscreen: ".laptop-mainscreen",
            laptopBackMainscreen: '[data-target="laptop-mainscreen"]',
            laptopEmail: ".js-laptop-email-screen",
            laptopEmailOpen: ".js-open-email",
            laptopEmailClose: '[data-dismiss="laptop-email"]',
            laptopHr: "#popup-hr-analytic",
            laptopHrOpen:
                '[data-open="popup"][data-target="#popup-hr-analytic"]',
            laptopHrClose: '#popup-hr-analytic [data-dismiss="popup"]',
            laptopHrOptSlider: ".laptop-hr-analytic",
            laptopHrOptSliderOpen: '[data-open="laptop-hr-analytic"]',
            laptopDocumentOpen:
                '[data-open="popup"][data-target="#popup-document-analytic"]',
            laptopDocumentClose:
                '#popup-document-analytic [data-dismiss="popup"]',

            openEmail: ".js-email-list",

            // Phase 2 Evidence
            laptopEvidence: ".evidence",
            laptopEvidenceOpen: ".evidence-select",
            laptopEvidenceSelectImage: ".evidence-select-image",
            laptopEvidenceSelectTitle: ".evidence-select-title",
            laptopEvidenceItem: ".evidence-item",
            laptopEvidenceItemImage: ".evidence-option-image",
            laptopEvidenceItemTitle: ".evidence-option-title",
            laptopEvidenceOptionWrapper: ".evidence-option-wrapper",
            laptopEvidenceOption: ".evidence-option",
            statement: ".mailbox-statement",
            statementCounter: ".mailbox-statement-counter",
            statementCounterCurrent:
                ".mailbox-statement-counter .current-length",
            statementInput: ".mailbox-statement-input",

            playroomImageboxShare: ".playroom-imagebox-share",

            textBoxPhase2: "#email-2-statement",
            emailView: ".js-email-view",
            snackbar: ".js-saved-document-snackbar",
            closeSnackbar: ".js-close-snackbar",
            backToList: ".js-back-to-lists",
            openCompose: ".js-email-compose-open",

            openSourceDOM: ".js-update-sourcedrop",
            sourceitem: ".js-sourcedrop",
            sourceSelector: ".js-sourcedrop-selector",
            sourceSelect: ".js-select-source",
            sourcePreview: ".js-source-item",
            sourcePlaceholder: ".js-source-placeholder",
            removeSource: ".js-remove-sourcedrop",
            statementPuzzle: ".js-statement",
            question: ".js-question",
            hintItems: ".js-hints-item",

            hintTimerBox: ".js-hint-timer-box",
            hintTimer: ".js-hint-timer",
            hintCounter: ".js-hint-counter",
        };

        this._events = this.getEvents();

        this._data = {};
        this._questions = [];
        this._labels = [];
        this.fbEvents = [];
        this.hintInterval = null;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;

        return [
            {
                event: "click",
                selector: elms.pointerBtn,
                handler: this.onHandlePointer,
            },
            {
                event: "click",
                selector: elms.closePopupBtn,
                handler: this.onCloseImagePopup,
            },
            {
                event: "click",
                selector: elms.openFullscreenBtn,
                handler: this.handleFullscreen,
            },
            {
                event: "click",
                selector: elms.closeFullscreenBtn,
                handler: this.onCloseFullsceenPopup,
            },
            {
                event: "click",
                selector: elms.shareBtn,
                handler: this.onAddDocument,
            },
            {
                event: "click",
                selector: elms.laptopOpen,
                handler: this.toggleLaptopScreen,
            },
            {
                event: "click",
                selector: elms.laptopClose,
                handler: this.toggleLaptopScreen,
            },
            {
                event: "click",
                selector: elms.laptopEmailOpen,
                handler: this.openEmailScreen,
            },
            {
                event: "click",
                selector: elms.openEmail,
                handler: this.onOpenMessage,
            },
            {
                event: "click",
                selector: ".email-compose",
                handler: this.onComposeEmail,
            },
            {
                event: "click",
                selector: elms.submitBtn,
                handler: this.onSubmit,
            },
            {
                event: "click",
                selector: elms.closeSnackbar,
                handler: this.onCloseSnackbar,
            },
            {
                event: "click",
                selector: elms.backToList,
                handler: this.onBackToList,
            },
            {
                event: "click",
                selector: elms.openCompose,
                handler: this.onOpenCompose,
            },
            {
                event: "click",
                selector: elms.openSourceDOM,
                handler: this.onToggleSource,
            },
            {
                event: "click",
                selector: elms.sourceSelect,
                handler: this.onSelectSource,
            },
            {
                event: "click",
                selector: elms.removeSource,
                handler: this.onRemoveSource,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.renderPlayRoom();
        this.setGameState();

        const roomStatus = getRoomStatus(this.roomId);
        if (roomStatus !== "is-status-completed") this.listenScannedUsers();
    }

    getModifiedData() {
        const modified = { ...this._data };

        const savedDocuments = getDocuments();
        let textSources = Object.values(savedDocuments).filter(
            (doc) => doc.type !== "image",
        );
        let imageSources = Object.values(savedDocuments).filter(
            (doc) => doc.type === "image",
        );

        textSources = textSources.map((doc) => {
            return {
                id: doc.id,
                title: doc.title,
                text: doc.text,
            };
        });

        imageSources = imageSources.map((doc) => {
            return {
                id: doc.id,
                title: doc.title,
                url: doc.url,
            };
        });

        const hintHotspots = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "hint",
        );

        const docsHotspot = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "document",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";

        const _hints = this._data.hints.map((hint, i) => {
            return {
                ...hint,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const _documents = this._data.documents.map((doc) => {
            const { document_id } = doc;
            const position = docsHotspot.find(
                (doc) => doc["document_id"] === document_id,
            );
            const position_top = position
                ? position["position_top"]
                : defaultValue;
            const position_left = position
                ? position["position_left"]
                : defaultValue;

            return {
                ...doc,
                position_top,
                position_left,
            };
        });

        const modifiedData = {
            ...modified,
            hints: _hints,
            documents: _documents,
            text_source_list: textSources,
            image_source_list: imageSources,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);
    }

    setGameState() {
        // const elms = this.elms;
        const roomID = this.roomId;

        getFeedback(roomID).then((data) => {
            const feedbacks = data.val() ?? {};

            if(Object.values(feedbacks).length > 0) {
                this.renderFeedback(feedbacks);
                // $(elms.backToList).trigger("click");
            }
        });

        this.handleHintVisibility();
    }

    handleHintVisibility() {
        const elms = this.elms;
        const $hintItems = $(elms.hintItems);
        const hintCount = $hintItems.length;
        let currentHintIndex = 0;
        const $firstHint = $hintItems.first();
        let hintTimerToActive = Number($firstHint.attr("data-timer"));
        const roomStartedAt = getRoomStartedAt(this.roomId, CONFIG.user.id);
        if(!roomStartedAt) return;

        if(hintCount === 0) return;

        if(this.hintInterval) {
            clearInterval(this.hintInterval);
            this.hintInterval = null;
        }

        const checkHints = () => {
            const now = Date.now();
            const minutesPassed = Math.floor((now - roomStartedAt) / 60000); //convert ms to minutes
            // let hintActiveId = null;

            $hintItems.each(function (index) {
                const $this = $(this);
                const hintTimer = Number($this.attr("data-timer"));
                if(minutesPassed >= hintTimer) {
                    // $hintItems.addClass("hidden");
                    $this.removeClass("hidden");
                    // hintActiveId = $this.attr("data-id");
                    const $nextHint = $this.next();
                    hintTimerToActive = $nextHint.length ? Number($nextHint.attr("data-timer")) : 0;
                    currentHintIndex = index + 1;
                }
            });

            if(hintTimerToActive > 0) {
                const nextHintTimer = hintTimerToActive;
                const nextHintTimerInMs = (nextHintTimer * 60000 + roomStartedAt) - now;
                const minutesToNextHint = Math.floor(nextHintTimerInMs / 60000);
                const secondsToNextHint = Math.floor((nextHintTimerInMs % 60000) / 1000);
                const minutesTxt = minutesToNextHint < 10 ? `0${minutesToNextHint}` : minutesToNextHint;
                const secondsTxt = secondsToNextHint < 10 ? `0${secondsToNextHint}` : secondsToNextHint;
                const nextHintTimerText =  `${minutesTxt}:${secondsTxt}`;

                $(elms.hintTimer).text(nextHintTimerText);
            }

            const nextHintCounter = `${currentHintIndex}/${hintCount}`;
            $(elms.hintCounter).text(nextHintCounter);

            // if last hint, hide timer box and clear interval
            if(currentHintIndex === hintCount) {
                $(elms.hintTimerBox).addClass("hidden");
                clearInterval(this.hintInterval);
            }
        }

        // Run immediately on page load
        checkHints();

        // Run every seconds
        this.hintInterval = setInterval(checkHints, 1000);
    }

    renderPlayRoom() {
        const startedAt = +new Date();
        const $playroom = $(".playroom").last();
        const $playroomImage = $playroom.find(".playroom-image");
        const $playroomWrapper = $playroom.find(".playroom-wrapper");

        // show error if onLoad not called more than 10s
        const waitLoad = setInterval(() => {
            const now = +new Date();
            const diff = now - startedAt;
            if (diff > 10 * 1000) {
                // showMessage(viewData.strings.playroom_image_error_load);
                clearInterval(waitLoad);
            }
        }, 100);

        const calculate = () => {
            const imageRatio = $playroomImage.height() / $playroomImage.width();
            const containerRatio = $playroom.height() / $playroom.width();

            let finalHeight;
            let finalWidth;

            if (containerRatio > imageRatio) {
                finalHeight = $playroom.height();
                finalWidth = $playroom.height() / imageRatio;
            } else {
                finalWidth = $playroom.width();
                finalHeight = $playroom.width() * imageRatio;
            }

            $playroomWrapper.css({
                height: finalHeight + "px",
                width: finalWidth + "px",
            });

            $playroomImage.css({
                height: finalHeight + "px",
                width: finalWidth + "px",
            });

            $playroom.addClass("is-calculated");
        };

        const markAsLoaded = () => {
            clearInterval(waitLoad);
        };

        const onLoad = () => {
            calculate();
            markAsLoaded();
        };

        // if image loaded directly from cached file, it wont trigger onload
        // @ts-ignore
        if ($playroomImage[0].complete) onLoad();
        $playroomImage.on("load", onLoad);
    }

    onHandlePointer(e) {
        const elms = this.elms;
        const $this = $(e.currentTarget);
        const $imagebox = $(elms.imageBox);
        const $title = $(".playroom-imagebox-title");
        const $description = $(".playroom-imagebox-description");
        const $image = $(".playroom-imagebox-image");
        const title = $this.attr("data-title");
        const docId = $this.attr("data-id");
        const description = $this.data("description");
        const image = $this.data("image");
        const isFullscreen = $this.hasClass("is-fullscreen");
        const newImage = new Image();

        // This is to determine whether tutorial can be shown or not
        // because Tutorial should only be open only if $imagebox is open
        // and $image has been loaded successfully
        // `I` stands for `imagebox`
        // let hasIOpened = false;
        // let hasILoaded = false;

        // const onFinishTransition = () => {
        //     // Prevent prematurely show tutorial when the email hasn't open yet
        //     if (!$imagebox.hasClass('is-open')) return false;

        //     hasIOpened = true;
        //     // showTutorial();
        // };

        // const transitionEndEvent = getTransitionEndEvent();
        // $imagebox.on(transitionEndEvent, onFinishTransition);

        newImage.src = image;
        newImage.onload = function () {
            $image.removeClass("is-loading");
            // hasILoaded = true;
            // showTutorial();
        };

        if (isFullscreen) {
            $imagebox.addClass("is-fullscreen");
        } else {
            $imagebox.removeClass("is-fullscreen");
        }

        $title.html(title);
        $description.html(description);
        $image.find("img").remove();
        $image.addClass("is-loading").append(newImage);
        $imagebox.addClass("is-open");

        $(elms.shareBtn).attr("data-id", docId);
        $(elms.shareBtn).attr("data-url", image);
        $(elms.shareBtn).attr("data-title", title);

        if (
            title.toLowerCase() == "ceo's laptop" ||
            title.toLowerCase() == "chairwoman's laptop"
        ) {
            $imagebox.addClass("is-ceo-laptop");
        } else {
            $imagebox.removeClass("is-ceo-laptop");
        }
    }

    onCloseImagePopup() {
        $(this.elms.imageBox).removeClass("is-open");
    }

    handleFullscreen() {
        const elms = this.elms;
        const $selectedImg = $(elms.imageBoxImg).find("img");
        const $imageboxFullscreen = $(elms.imageBoxFullscreen);
        const $fullscreenWrapper = $imageboxFullscreen.find(
            ".popup-fullscreen-wrapper",
        );
        const $existingImg = $fullscreenWrapper.find("img");

        if ($existingImg.length) {
            $existingImg.removeClass("is-active");
            $existingImg.remove();
        }

        $selectedImg
            .clone(true)
            .addClass("is-active")
            .appendTo($fullscreenWrapper);
        $imageboxFullscreen.addClass("is-open");
    }

    onCloseFullsceenPopup() {
        const elms = this.elms;
        const $imageboxFullscreen = $(elms.imageBoxFullscreen);
        $imageboxFullscreen.removeClass("is-open");
    }

    onAddDocument(e) {
        const $this = $(e.currentTarget);
        const id = $this.attr("data-id");
        const url = $this.attr("data-url");
        const title = $this.attr("data-title");
        const type = "image";

        const docObj = {
            [id]: {
                url,
                title,
                type,
            },
        };

        addDocument(docObj)
            .then(() => {
                $(".js-saved-document-snackbar").addClass("is-open");
                setTimeout(() => {
                    $(".js-saved-document-snackbar").removeClass("is-open");
                }, 3000);
            })
            .catch(() => console.error("failed"));
    }

    onCloseSnackbar() {
        $(this.elms.snackbar).removeClass("is-open");
    }

    onBackToList() {
        const elms = this.elms;
        const $emailScreen = $(elms.laptopEmail);
        $emailScreen.find(".email-mailbox.is-open").removeClass("is-open");
        $emailScreen.find(".email-compose").removeClass("is-compose-open");
    }

    onOpenCompose() {
        const elms = this.elms;
        const $emailScreen = $(elms.laptopEmail);
        $emailScreen.find(".email-compose").addClass("is-compose-open");
    }

    onToggleSource(e, el) {
        const $el = $(el);
        const elms = this.elms;

        const hasOpen = $el.parents(elms.sourceitem).hasClass("is-open");
        const isOpen = !hasOpen;

        $el.parents(elms.sourceitem).toggleClass("is-open", isOpen);
    }

    onSelectSource(e, el) {
        const $el = $(el);
        const elms = this.elms;
        const $sourceItem = $el.parents(elms.sourcePreview);
        const sourceType = $sourceItem.attr("data-type");
        const $clonepreview = $sourceItem.clone();
        const $placeholder = $el
            .parents(elms.sourceitem)
            .find(".js-source-placeholder");

        if (sourceType !== "image") {
            const sourceText = $sourceItem.attr("data-text");
            $clonepreview.find(".js-source-txt").html(sourceText);
        }

        $placeholder.empty();
        $clonepreview.prependTo($placeholder);
        $sourceItem.removeClass("is-selected");
        $el.parents(elms.sourcePreview).addClass("is-selected");
        $el.parents(elms.sourceitem)
            .removeClass("is-open")
            .addClass("is-filled");

        this.toggleSendBtn();
    }

    onRemoveSource(e, el) {
        const $el = $(el);
        const elms = this.elms;
        const $placeholder = $el
            .parents(elms.sourceitem)
            .find(".js-source-placeholder");
        const $question = $el.parents(elms.question);

        $question.removeClass(
            "is-incorrect-statement is-correct-statement is-incorrect-source is-correct-source",
        );

        $(".js-select-source").prop("checked", false);
        $(".js-source-item").removeClass("is-selected");
        $placeholder.empty();
        $el.parents(elms.sourceitem).removeClass("is-filled");

        this.toggleSendBtn();
    }

    toggleSendBtn() {
        const elms = this.elms;
        const $sendBtn = $(elms.submitBtn);
        const $statement = $(elms.statementPuzzle);
        let isAllFilled = true;

        $.each($statement, function (index, item) {
            const $this = $(item);
            const $sourceItem = $this.find(elms.sourceitem);
            const isFilled = $sourceItem.hasClass("is-filled");

            if (!isFilled) {
                return (isAllFilled = false);
            }
        });

        $sendBtn.prop("disabled", !isAllFilled);
    }

    toggleLaptopScreen() {
        const elms = this.elms;
        const $laptopScreen = $(elms.laptop);
        const isOpened = $laptopScreen.hasClass("is-open");

        $laptopScreen.toggleClass("is-open", !isOpened);
        $(".app__brand").toggleClass("is-hidden", !isOpened);
    }

    setNewEmailButtonAndPrepareData = () => {
        var phase = 1;
        // if (window.phase2Passed) phase = 3;
        // else if (window.phase1Passed) phase = 2;
        // else phase = 1;

        $(".email-compose .phase").text(` (phase ${phase})`);
        $(".email-compose").data("target-class", `template-phase-${phase}`);
        $('.template-phase-2 button[type="submit"]').attr(
            "disabled",
            "disabled",
        );
    };

    openEmailScreen() {
        const elms = this.elms;
        const $emailScreen = $(elms.laptopEmail);

        $emailScreen.addClass("is-open");

        this.setNewEmailButtonAndPrepareData();
        $(".email-compose").trigger("click");
    }

    onComposeEmail() {
        $(".email-page .email-mailbox.is-open").removeClass("is-open");
        $(".email-compose .email-mailbox").addClass("is-open");
    }

    onIncorrectAnswer() {}

    onOpenMessage(e) {
        const $this = $(e.currentTarget);
        const id = $this.attr("data-id");
        const isFeedback = $this.hasClass("is-feedback");

        $(".email-mailbox.is-open").removeClass("is-open");
        $(`${this.elms.emailView}`).removeClass("is-open");
        $(`${this.elms.emailView}[data-id="${id}"]`).addClass("is-open");

        if(isFeedback) {
            const hasSeen = this.getHasSeenFeedback(id);
            if(!hasSeen) {
                this.setHasSeenFeedback(id);
                $(`${this.elms.emailList}[data-id="${id}"]`).removeClass("is-new");
            }
        }
    }

    getHasSeenFeedback(feedbackID) {
        const roomID = this.roomId;
        const states = Storage.get("states", {});
        const savedFeedback = states?.feedback?.[roomID] || [];
        return savedFeedback.includes(String(feedbackID));
    }

    setHasSeenFeedback(feedbackID) {
        const roomID = this.roomId;
        let states = Storage.get("states", {});
        if (!states?.feedback) states.feedback = {};
        if (!states?.feedback?.[roomID]) states.feedback[roomID] = [];
        states.feedback[roomID].push(feedbackID);

        return Storage.set("states", states);
    }

    onSubmit() {
        const elms = this.elms;
        const roomID = this.roomId;
        const { reference_room, source_feedback } = this._data;
        const correctSources = getRoomAnswerById(reference_room);
        const totalCorrectSource = Object.keys(correctSources).length;
        let roomStatus = "is-status-started";

        const $statements = $(elms.statementPuzzle);
        let playerAnswers = [];
        let correctCount = 0;
        let sourceFeedback = {};

        $.each($statements, function (index, item) {
            const $this = $(item);
            const type = $this.attr("data-type");
            const $sourceDropPlaceholder = $this.find(".js-source-placeholder");
            const $selectedItem = $sourceDropPlaceholder.children();
            const itemID = $selectedItem.find("input").attr("value");

            const correctAnswer = correctSources?.[type] || [];
            const isCorrect = correctAnswer.includes(itemID);

            if (isCorrect) { 
                playerAnswers[type] = itemID;
                correctCount++;
            } else {
                const theFeedback = source_feedback.find(
                    (item) => item.document_id === itemID || item.item_id === itemID);
                if(theFeedback) {
                    sourceFeedback[type] = theFeedback?.feedback_response;
                }
            }
        });

        if (totalCorrectSource === correctCount) {
            roomStatus = "is-status-completed";
        } else {
            const {
                sender_email,
                sender_name,
                subject,
                general_feedback,
            } = this._data;
            const generalFeedback = general_feedback?.find?.(
                (item) => Number(item.correct_source) === correctCount,
            );
            const feedbackText = generalFeedback?.feedback_text || "";
            const allTexts = [feedbackText, ...Object.values(sourceFeedback)];
            const fullTextBody = allTexts.join("\n\n");

            const feedbackData = {
                [Date.now()]: {
                    senderEmail: sender_email,
                    senderName: sender_name,
                    subject,
                    body: fullTextBody,
                    time: "now",
                    createdAt: Date.now(),
                }
            }

            getFeedback(roomID).then((data) => {
                const feedbacks = data.val() ?? {};
                const newFeedbacks = { ...feedbacks, ...feedbackData };

                updateFeedback(roomID, newFeedbacks)
                .then(() => {
                    $(elms.backToList).trigger("click");
                });
            });
        }

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    htmlToPlainTextPreserveNewLines(text) {
        return $("<div>")
          .html(
            text
              .replace(/<br\s*\/?>/gi, '\n')          // replace <br> with newline
              .replace(/<\/p>|<\/div>|<\/li>/gi, '\n') // replace closing block tags with newline
          )
          .text()
          .trim();
      }

    renderFeedback(feedbacks) {
        const elms = this.elms;

        if (Object.values(feedbacks).length > 0) {
            for(const feedback of Object.values(feedbacks)) {
                const $emailList = $(elms.openEmail).first();
                const $emailView = $(elms.emailView).first();
                const $feedbackEmail = $emailList.clone();
                const $feedbackView = $emailView.clone();

                const { 
                    senderName, 
                    senderEmail, 
                    subject, 
                    body, 
                    time, 
                    createdAt,
                } = feedback;

                const isRendered = $(`${elms.emailView}[data-id="${createdAt}"]`)
                    .length > 0;
                if(isRendered) continue;

                // Convert HTML to plain text directly
                // const cleanBody = $("<div>").html(savedFeedback.body).text();
                const cleanBody = this.htmlToPlainTextPreserveNewLines(body);
                
                const truncatedBody = cleanBody.slice(0, 50);
                $feedbackEmail
                    .find(".message-title")
                    .html(
                        `${senderName} - ${senderEmail}`,
                    );
                $feedbackEmail.find(".message-timestamp").html(time);
                $feedbackEmail
                    .find(".message-content-title")
                    .html(subject);
                $feedbackEmail.find(".message-content-body").text(truncatedBody);
                $feedbackEmail.addClass("is-feedback").attr("data-id", createdAt);
                
                const hasSeen = this.getHasSeenFeedback(createdAt);
                if(!hasSeen) {
                    $feedbackEmail.addClass("is-new");
                }

                $feedbackView.addClass("is-feedback").attr("data-id", createdAt);
                $feedbackView
                    .find("#respond-sender")
                    .html(senderEmail);
                $feedbackView.find("#respond-subject").html(subject);
                $feedbackView.find("#respond-body").html(body);

                $feedbackEmail.insertBefore($emailList);
                $feedbackView.insertBefore($emailView);
            }
        }
    }

    maybeAllAnswersCorrect() {
        const elms = this.elms;
        const roomID = this.roomId;
        const roomAnswers = getRoomAnswerById(roomID);
        const totalRoomAnswers = Object.keys(roomAnswers).length;
        const $question = $(elms.question);
        const totalCorrectStatement = $(
            `${elms.question}.is-correct-statement`,
        ).length;
        const totalCorrectSource = $(
            `${elms.question}.is-correct-source`,
        ).length;

        if (
            totalCorrectStatement === totalRoomAnswers &&
            totalCorrectSource === totalRoomAnswers
        ) {
            $.each($question, function (index, item) {
                const questionID = $(item).attr("data-id");
                const $statement = $(item).find(elms.statement);
                const statementTxt = $statement.val();

                const $sourcePlaceholder = $(item).find(
                    ".js-source-placeholder",
                );
                const $selectedSource =
                    $sourcePlaceholder.find(".js-source-item");
                const selectedSourceId = $selectedSource
                    .find(".js-select-source")
                    .attr("id");

                const userAnswer = {
                    [questionID]: {
                        statement: statementTxt,
                        source: selectedSourceId,
                    },
                };

                const onSuccessUpdate = () => {
                    maybeUpdateRoomStatus(roomID, "is-status-completed");
                };

                const onErrorUpdate = () => {};

                updateFinalRoomAnswer(roomID, userAnswer)
                    .then(onSuccessUpdate)
                    .catch(onErrorUpdate);
            });
        }
    }

    rerenderImageSourceList() {
        const elms = this.elms;
        const $imageStatement = $(`${elms.statementPuzzle}[data-type="image"]`);
        const $sourceSelector = $imageStatement.find(elms.sourceSelector);
        const $sourceSelectorInner = $sourceSelector.find(".selectorInner");
        const $theTemplate = $("#source-template-image").html();

        $sourceSelectorInner.empty();

        const savedDocuments = getDocuments();
        const imageSources = Object.values(savedDocuments).filter(
            (doc) => doc.type === "image",
        );

        const html = compile($theTemplate, { image_source_list: imageSources });
        $sourceSelectorInner.html(html);
    }

    listenScannedUsers(off = false) {
        // const roomID = this.roomId;
        const path = `${fb.documentPath}`;
        const rerender = () => this.rerenderImageSourceList();

        if(off) {
            this.fbEvents.forEach((fn) => fn.call());
            this.fbEvents = [];
        } else {
            const docListener = fb.onValue(path, rerender);

            this.fbEvents.push(docListener);
        }
    }

    beforeDestroy() {
        this.listenScannedUsers(true);
        if(this.hintInterval) clearInterval(this.hintInterval);
    }
}
